<app-reports-toolbar></app-reports-toolbar>
<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>
<div class="container-fluid px-0">
  <div class="row ms-4 me-3">
    <div class="me px-0">
      <div id="div1">
        NAMC/PDC
      </div>
      <div>

        <mat-form-field appearance="outline" class="fixed-select" style="height:26px !important">
          <mat-select [(ngModel)]="selectedImportPlant" [multiple]="true" [panelWidth]="null">
            <div class="search-all-option">
              <mat-checkbox
                [checked]="isAllSelected(selectedImportPlant,dropdownOptionimportPlant)"
                [indeterminate]="isIndeterminate(selectedImportPlant,dropdownOptionimportPlant)"
                (change)="selectedImportPlant = toggleSelectAll($event,dropdownOptionimportPlant)">
              </mat-checkbox>
              <ngx-mat-select-search [formControl]="namcFilterCtrl" placeholderLabel="Search"
                noEntriesFoundLabel="No options found">
              </ngx-mat-select-search>
            </div>
            <div style="max-height: 195px; overflow-y: auto;">
              <mat-option *ngFor="let d of filteredNamc | async" [value]="d" style="font-size: 13px;">
                {{ d.value }}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>

      </div>

      <div id="div2">
        LP
      </div>
      <div>

        <mat-form-field appearance="outline" class="fixed-select" style="height:26px !important">
          <mat-select [(ngModel)]="selectedImportLP" [multiple]="true" [panelWidth]="null">
            <div class="search-all-option">
              <mat-checkbox [checked]="isAllSelected(selectedImportLP,dropdownOptionimportLP)"
                [indeterminate]="isIndeterminate(selectedImportLP,dropdownOptionimportLP)"
                (change)="selectedImportLP = toggleSelectAll($event,dropdownOptionimportLP)">
              </mat-checkbox>
              <ngx-mat-select-search [formControl]="lpFilterCtrl" placeholderLabel="Search"
                noEntriesFoundLabel="No options found">
              </ngx-mat-select-search>
            </div>
            <div style="max-height: 195px; overflow-y: auto;">
              <mat-option *ngFor="let d of filteredLp | async" [value]="d" style="font-size: 13px;">
                {{ d.value }}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>

      </div>
      <div id="div3">
        Route Type
      </div>
      <div>

        <mat-form-field appearance="outline" class="fixed-select" style="height:26px !important">
          <mat-select [(ngModel)]="selectedImportRoute" [multiple]="true" [panelWidth]="null">
            <div class="search-all-option">
              <mat-checkbox
                [checked]="isAllSelected(selectedImportRoute,dropdownOptionimportRoute)"
                [indeterminate]="isIndeterminate(selectedImportRoute,dropdownOptionimportRoute)"
                (change)="selectedImportRoute = toggleSelectAll($event,dropdownOptionimportRoute)">
              </mat-checkbox>
              <ngx-mat-select-search [formControl]="routeFilterCtrl"
                placeholderLabel="Search" noEntriesFoundLabel="No options found">
              </ngx-mat-select-search>
            </div>
            <div style="max-height: 195px; overflow-y: auto;">
              <mat-option *ngFor="let d of filteredRoute | async" [value]="d" style="font-size: 13px;">
                {{ d.value }}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </div>


    </div>

  </div>
</div>
<br>


<button class="roboto-bold ms-4" (click)='download()' id="btn">FETCH REPORT</button>